






















import {defineComponent} from '@vue/composition-api'
import {useGetters} from 'vuex-composition-helpers'
import AttendedActivity from "../shared/Activity/AttendedActivity.vue"
import ListAtom from "@/shared/components/atoms/card/ListAtom.vue"
import {GetterTree} from "vuex"
import {MyStudyChoiceActivitiesState} from "@/apps/MyStudyChoiceActivitiesWidget/models/store-viewmodel"

export default defineComponent({
    name: "ActivityAttendedComponent",
    components: {
        AttendedActivity,
        ListAtom
    },
    setup: () => {
        const {
            getConfig,
            attendedActivities
        } = useGetters<GetterTree<MyStudyChoiceActivitiesState, MyStudyChoiceActivitiesState>>([
            'getConfig', 'attendedActivities'
        ])
        return {getConfig, attendedActivities}
    }

})
